<template>
  <a
    :href="anchor"
    :class="`anchor ${linkColor}`"
    style="margin-inline-start: var(--anchor-margin-inline-start, -2.625em)"
  >
    <font-awesome-icon
      :icon="$v7.solid.faLinkHorizontal"
      size="xl"
    />
    <span class="sr-only">Link to {{ anchorName }} on this page</span>
  </a>
</template>
<script>
  export default {
    name: 'AnchorLink',

    props: {
      linkColor: {
        type: String,
        default: 'blue'
      },
      anchor: {
        type: String,
        required: true
      },
      anchorName: {
        type: String,
        required: true
      }
    }
  }
</script>
